webpackJsonp([114276838955818,60335399758886],{

/***/ 130:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(280);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(130);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(231);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _typography = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var isHome = _ref.isHome,
	      children = _ref.children;
	
	  var Heading = isHome ? 'h1' : 'h3';
	
	  var headingStyles = {
	    h1: _extends({}, (0, _typography.scale)(1.5), {
	      marginTop: 0,
	      marginBottom: (0, _typography.rhythm)(1.5)
	    }),
	    h3: {
	      fontFamily: 'Montserrat, sans-serif',
	      marginTop: 0,
	      marginBottom: (0, _typography.rhythm)(-1)
	    }
	  };
	
	  var linkStyle = {
	    boxShadow: 'none',
	    textDecoration: 'none',
	    color: 'inherit'
	  };
	
	  return _react2.default.createElement(
	    Heading,
	    { style: headingStyles[Heading] },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { style: linkStyle, to: '/' },
	      children
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _typography = __webpack_require__(21);
	
	var _Header = __webpack_require__(279);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Template = function Template(_ref) {
	  var location = _ref.location,
	      children = _ref.children;
	
	  var rootPath =  false ? __PATH_PREFIX__ + '/' : '/';
	
	  var isHome = location.pathname === rootPath;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        marginLeft: 'auto',
	        marginRight: 'auto',
	        maxWidth: (0, _typography.rhythm)(24),
	        padding: (0, _typography.rhythm)(1.5) + ' ' + (0, _typography.rhythm)(3 / 4)
	      }
	    },
	    _react2.default.createElement(
	      _Header2.default,
	      { isHome: isHome },
	      _react2.default.createElement(
	        'abbr',
	        { title: 'Sud-Ouest' },
	        'SO'
	      ),
	      ' VTT'
	    ),
	    children()
	  );
	}; /* global __PREFIX_PATHS__:false, __PATH_PREFIX__:false */
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-09be93cd12c28595e6f3.js